import { c as _c } from "react/compiler-runtime";
import { CloseIcon, Divider, FontWeights } from "@flat-ui";
import { Box, Stack } from "@mui-wrapper";
import { ProgressCard } from "@components/progress-overview/progress-card";
import { useAppSelector } from "@store/store-helper";
import { appStateSelector } from "@store/app/app-selector";
import { colorConst } from "@styles/common-colors";
/** Renders a failed or in-progress section in project overview */
export function ProgressOverviewSectionItem(t0) {
  const $ = _c(29);
  const {
    label,
    tasks
  } = t0;
  const {
    isDevModeEnabled
  } = useAppSelector(appStateSelector);
  let t1;
  if ($[0] !== isDevModeEnabled || $[1] !== tasks) {
    t1 = isDevModeEnabled ? tasks.reduce(_temp, 0).toFixed(2) : 0;
    $[0] = isDevModeEnabled;
    $[1] = tasks;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const speedMBps = t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      justifyContent: "space-between",
      textTransform: "uppercase",
      color: "gray850",
      fontWeight: FontWeights.Bold,
      fontSize: "0.8em",
      mx: 4,
      mt: 2,
      alignItems: "center"
    };
    t3 = {
      display: "flex",
      alignItems: "center"
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CloseIcon sx={{
      color: "red500"
    }} />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      opacity: "0.6"
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== tasks.length) {
    t6 = <var style={t5}>({tasks.length})</var>;
    $[7] = tasks.length;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== label || $[10] !== t6) {
    t7 = <div style={t3}>{t4} {label}  {t6}</div>;
    $[9] = label;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = isDevModeEnabled ? colorConst.devFeature : undefined;
  let t9;
  if ($[12] !== t8) {
    t9 = {
      color: t8
    };
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = isDevModeEnabled && `${speedMBps} MB/s`;
  let t11;
  if ($[14] !== t10 || $[15] !== t9) {
    t11 = <var style={t9}>  {t10}</var>;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t7) {
    t12 = <Stack direction="row" sx={t2}>{t7}{t11}</Stack>;
    $[17] = t11;
    $[18] = t7;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== isDevModeEnabled || $[21] !== tasks) {
    let t14;
    if ($[23] !== isDevModeEnabled) {
      t14 = (task_0, i) => <ProgressCard task={task_0} isDevMode={isDevModeEnabled} key={i} />;
      $[23] = isDevModeEnabled;
      $[24] = t14;
    } else {
      t14 = $[24];
    }
    t13 = tasks.map(t14);
    $[20] = isDevModeEnabled;
    $[21] = tasks;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Divider />;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t12 || $[27] !== t13) {
    t15 = <Box>{t12}{t13}{t14}</Box>;
    $[26] = t12;
    $[27] = t13;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  return t15;
}
function _temp(acc, task) {
  return acc + (task.speedMBps ?? 0);
}